import React from 'react';
import Lottie from 'lottie-react';
import loadingAnimation from '../assets/loading.json';

interface LoadingSpinnerProps {
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 200, 
  className = '',
  style = {}
}) => {
  return (
    <div 
      className={`loading-spinner ${className}`}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        ...style
      }}
    >
      <Lottie
        animationData={loadingAnimation}
        style={{ width: size, height: size }}
        loop={true}
        autoplay={true}
      />
    </div>
  );
};

export default LoadingSpinner; 